/*
  Golden Hour cart: marks the cart drawer after an add, so the line
  "Item added to your cart" (snippets/ghw-cart-added.liquid) shows. The flag
  lives on <theme-drawer id="cart-drawer">, which Horizon does not morph on
  cart updates, so it survives the re-render. Any other cart change (quantity,
  remove, discount) or closing the drawer clears it.

  The event is Shopify's standard cart event, "shopify:cart:lines-update",
  which carries `action` ('add' | 'update' | 'clear'). The older "cart:update"
  name is kept as a fallback for any code that still dispatches it.
*/
(function () {
  var EVENTS = ['shopify:cart:lines-update', 'cart:update'];

  function drawer() {
    return document.getElementById('cart-drawer');
  }

  function onCartUpdate(event) {
    var el = drawer();
    if (!el) return;
    var action = event && (event.action || (event.detail && event.detail.action));
    if (action === 'add') {
      el.setAttribute('data-ghw-added', '');
    } else {
      el.removeAttribute('data-ghw-added');
    }
  }

  for (var i = 0; i < EVENTS.length; i++) {
    document.addEventListener(EVENTS[i], onCartUpdate);
  }

  document.addEventListener('theme-drawer:close', function (event) {
    var el = drawer();
    if (!el) return;
    if (event.target === el || el.contains(event.target)) {
      el.removeAttribute('data-ghw-added');
    }
  });
})();
